export const defaultColor = "#3514FF";
